import {Injectable, Inject} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {getAttributesMap, getVid} from '../../appConfig/appConfigForward';
import {FullViewLinksService} from './links/serviceLinks.service';
import {RtaService} from '../rta.service';
import {LocationService} from './getit/opac/locations/location/location.service';
import {RecordUtil} from '../../infra/RecordUtil.service';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {CitationTrailsFullviewLinkService} from '../citationTrails/citationTrailsFullviewLink.service';
import {TimesCitedService} from "../timesCited/timesCited.service";
import {NewspapersService} from '../../newspapers/newspapers.service';
import {STATE_NAMES} from "../../primoExplore/primoExploreStates.module";
import {MoreLikeThisService} from "../moreLikeThis/moreLikeThis.service";
import {CollectionDiscoveryService} from "../../collectionDiscovery/collectionDiscovery.service";
const get = require('lodash/get');

var angular: angular.IAngularStatic = require('angular');
const findIndex = require('lodash/findIndex');
const indexOf = require('lodash/indexOf');
const _get = require('lodash/get');
let union = require('lodash/union');
const find = require('lodash/find');
const forEach = require('lodash/forEach');
const GS_STRING_DELIMITER = ";";

@Injectable()
export class FullViewService {
    public servicesDirectives: Object;
    private services: Object;
    public servicesArray: Object;
    private vid: string = getVid();
    private calculateSvcIdDone: boolean = false;
    private calculatePcDeliveryDone: boolean = false;
    private _calculatePrimaViewItDeliveryDone: boolean = false;
    private displaySearchWithinJournal: boolean;
    private _lang3: string;
    public nextOffset: Object = {};
    public totalItems: Object = {};
    public moreLikeThisItems: Object = {};
    public moreLikeThisUnfilteredItems: Object = {};
    public isPromiseResolved: boolean =false;
    
    private servicesToFilter = ['details', 'reviewsandtags', 'onlinereviews', 'browseshelf', 'moreLikeThisCourse', 'moreLikeThisCollection'];
    public viewOnlineScrollId: string;

    constructor(private collectionDiscoveryService: CollectionDiscoveryService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs: Object,
                private configurationUtil: ConfigurationUtil,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$q') private $q: ng.IQService,
                private mappingTablesCache: MappingTablesCache,
                private linksService: FullViewLinksService,
                private rtaService: RtaService,
                private locationService: LocationService,
                private recordUtil: RecordUtil,
                private citationTrailsFullviewLinkService: CitationTrailsFullviewLinkService,
                private timesCitedService: TimesCitedService,
                private moreLikeThisService: MoreLikeThisService,
                private newspapersService: NewspapersService) {
        this.configurationUtil = configurationUtil;
        this.servicesDirectives = {
            'brief': {
                scrollId: 'brief',
                serviceName: 'brief',
                title: 'nui.brief.results.tabs.brief'
            },
            'citations': {
                scrollId: 'citationTrails',
                serviceName: 'citationTrails',
                title: 'citation_trail.link.citations',
                conditional: (item: PrimoResponse.IDoc) => {
                    return (this.recordUtil.hasCitationTrails(item) && this.citationTrailsFullviewLinkService.shouldDisplayCitationTrial()) || this.citationTrailsFullviewLinkService.shouldDisplayTimesCited();
                }
            },
            'action_list': {
                scrollId: 'action_list',
                serviceName: 'action_list',
                title: 'nui.brief.results.tabs.send_to'
            },
            'getit_link2': {
                serviceName: 'getit_link2', title: 'Get it 2'
            },
            'getit_link1': {
                scrollId: 'getit_link1',
                serviceName: 'getit_link1',
                title: 'brief.results.tabs.locations'
            },
            'tags': {
                scrollId: 'tags',
                serviceName: 'tags',
                title: 'brief.results.tabs.tags'
            },
            'ngrs': {
                scrollId: 'ngrs',
                serviceName: 'ngrs',
                title: 'brief.results.tabs.Get_it_from_other_locations'
            },
            'details': {
                scrollId: 'details',
                serviceName: 'details',
                title: 'brief.results.tabs.details'
            },
            'links': {
                scrollId: 'links',
                serviceName: 'links',
                title: 'nui.brief.results.tabs.links'
            },
            'browseshelf': {
                scrollId: 'virtualBrowse',
                serviceName: 'virtualBrowse',
                title: 'brief.results.tabs.browseshelf'
            },
            'moreLikeThisCourse': {
                scrollId: 'moreFromTheSameCourse',
                serviceName: 'moreLikeThisCourse',
                title: 'nui.brief.results.tabs.courseTab',
                tabTitle: 'nui.brief.results.tabs.moreCourse',
                conditional: (item: PrimoResponse.IDoc) => {
                    return getAttributesMap().moreLikeCourse ? getAttributesMap().moreLikeCourse : false;
                }
            },
            'moreLikeThisCollection': {
                scrollId: 'moreFromTheSameCollection',
                serviceName: 'moreLikeThisCollection',
                title: 'nui.brief.results.tabs.collectionTab',
                tabTitle: 'nui.brief.results.tabs.moreCollection',
                conditional: (item: PrimoResponse.IDoc) => {
                    return getAttributesMap().moreLikeCollection ? getAttributesMap().moreLikeCollection : false;
                }
            },
            'searchWithinJournal': {
                scrollId: 'searchWithinJournal',
                serviceName: 'searchWithinJournal',
                title: 'brief.results.tabs.searchWithinJournal'
            }, 'timesCited': {
                scrollId: 'citationTrails',
                serviceName: 'timesCited',
                title: 'citation_trail.link.citations',
                conditional: (item: PrimoResponse.IDoc) => {
                    return this.timesCitedService.shouldDisplayTimesCited;
                }
            }
//                                        'reviewsandtags'  : {'<prm-customization-iframe url-template-id="fullViewUrl"></prm-customization-iframe>'},

//                    'recommendations': {},
//                    'citations': {},
//                    'onlinereviews': {},
//                    'browseshelf': {}
        };

        this.services = [];
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            let index = this.servicesToFilter.indexOf('details');
            if (index > -1) {
                this.servicesToFilter.splice(index, 1);
            }
        }
        this.calculateSvcIdDone = false;
        this.calculatePcDeliveryDone = false;

    }

    public async getServices(item: PrimoResponse.IDoc, originator: string, haveNewDelivery?: boolean) {
        if (!this.servicesArray || haveNewDelivery) {
            return this.updateServices(item, originator, haveNewDelivery);
        }
        return this.servicesArray;
    }

    get lang3(): string {
        return this._lang3;
    }

    set lang3(value: string) {
        this._lang3 = value;
    }


    public updateServices(item: PrimoResponse.IDoc, originator: string, haveNewDelivery?: boolean) {
        if (this.isCall && !haveNewDelivery) {
            return;
        }
        this.isCall =true;
        this.lang3 = item.lang3;
        let services = this.configurationUtil.getBriefResultConfiguration().tabsorder.items.split(',')
            .filter((value, index, arr) => this.servicesDirectives[value])
            .map((value, index, arr) => {
                return this.servicesDirectives[value];
            });
        let promisesArr = [];
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            services = this.handleCitationTrialsAndTimesCitedVisibilityForSuprima(services, this.citationTrailsFullviewLinkService, this.timesCitedService);
        }
        let getItExpanded = this.parseServicesWithConfiguration(item, 'getit_link1');
        let getIt2Expanded = this.parseServicesWithConfiguration(item, 'getit_link2');
        let servicesToDisplay =
            [this.parseServicesWithConfiguration(item, 'brief')]
                .concat([this.parseServicesWithConfiguration(item, 'action_list')])
                .concat(services);

        if (!this.configurationUtil.isSuprima() && !(this.newspapersService.isNewspapersSearch() || this.newspapersService.isNewspaperItem(item))) {
            servicesToDisplay = servicesToDisplay.concat([this.parseServicesWithConfiguration(item, 'tags')]);
        } else {
            let mainMenuConfiguration = this.configurationUtil.getMainMenuConfiguration();
            let tags = find(mainMenuConfiguration.mainview, (e) => e.label === 'tags');
            if (!tags || this.configurationUtil.getSummonOverAlma()) {
                let tagsIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'tags');
                servicesToDisplay.splice(tagsIndex, 1);
            }
        }

        // More Like This Service

        // Course
        if (_get(item, 'pnx.search.crsid') || _get(item, 'pnx.display.crsinfo')) {
            let courseConf = this.parseServicesWithConfiguration(item, 'moreLikeThisCourse');
            if(courseConf.conditional(item)){
                promisesArr.push(this.moreLikeThisService.getItemsForSameField(item, 'crs').then((response) => {
                    this.setResultFields(response, item, 'crs');
                    if (this.moreLikeThisItems['crs'] && this.moreLikeThisItems['crs'].length > 0) {
                        servicesToDisplay = servicesToDisplay.concat([courseConf]);
                    } else {
                        servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCourse');
                        this.setResultFields(undefined, item, 'moreLikeThisCourse');
                    }
    
                }, (rej) => {
                }).finally(() => {
                    this.moreLikeThisService.itemsSearchInProgress = false;
                }));
            }
        } else {
            servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCourse');
            this.setResultFields(undefined, item, 'moreLikeThisCourse');
        }

        // Collection
        if (_get(item, 'pnx.search.cdparentid')  || _get(item, 'pnx.control.colldiscovery')) {
            let collectionConf = this.parseServicesWithConfiguration(item, 'moreLikeThisCollection');
            if(collectionConf.conditional(item)){
                promisesArr.push(this.moreLikeThisService.getItemsForSameField(item, 'col').then((response) => {
                    this.setResultFields(response, item, 'col');
                    if (this.moreLikeThisItems['col'] && this.moreLikeThisItems['col'].length > 0) {
                        servicesToDisplay = servicesToDisplay.concat([collectionConf]);
                    } else {
                        servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCollection');
                        this.setResultFields(undefined, item, 'moreLikeThisCollection');
                    }
                }, (rej) => {
                }).finally(() => {
                    this.moreLikeThisService.itemsSearchInProgress = false;
                }));
            }
        } else {
            servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCollection');
            this.setResultFields(undefined, item, 'moreLikeThisCollection');
        }

        // More Like This Service - End

        if (!(item.enrichment && item.enrichment.virtualBrowseObject && item.enrichment.virtualBrowseObject.isVirtualBrowseEnabled)) {
            servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'virtualBrowse');
        }

        if (this.configurationUtil.getBackendSystem() !== 'suprima') {
            if (this.linksService.hasLinks(item)) {
                let detailsServiceIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'details');
                servicesToDisplay.splice(detailsServiceIndex + 1, 0, this.parseServicesWithConfiguration(item, 'links'));
            }
        } else {
            if (!this.linksService.hasLinks(item)) {
                let linksServiceIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'links');
                servicesToDisplay.splice(linksServiceIndex, 1);
            }
        }

        let index = findIndex(servicesToDisplay, (obj) => obj.serviceName === 'getit_link1');
        servicesToDisplay = servicesToDisplay.filter(
            (value, index, arr) => value.serviceName !== 'getit_link1'
        );
        servicesToDisplay = servicesToDisplay.slice(0, index)
            .concat(getItExpanded)
            .concat(servicesToDisplay.slice(index));

        if (angular.isDefined(getIt2Expanded)) {
            let changed = false;
            for (let i = 0; i < servicesToDisplay.length; i++) {
                if (servicesToDisplay[i].serviceName == "getit_link2") {
                    servicesToDisplay[i] = getIt2Expanded[0];
                    changed = true;
                    break;
                }
            }
            if (!changed) {
                servicesToDisplay = servicesToDisplay.concat(getIt2Expanded);
            }
        } else {
            servicesToDisplay = servicesToDisplay.filter((obj) => {
                return obj.serviceName != "getit_link2"
            })
        }


        //if current state is services page, filter the unneedded services that are defined in servicesToFilter
        if (this.$state.current.name === STATE_NAMES.SERVICE_PAGE) {
            servicesToDisplay = servicesToDisplay.filter((value) =>
                findIndex(this.servicesToFilter, (obj) => obj === value.serviceName) < 0
            );
            if (this.configurationUtil.getBackendSystem() === 'suprima') {
                if (!this.configurationUtil.getSummonOverAlma() || !this.isLocalRecord(item)) {
                    let detailsServiceIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'details');
                    servicesToDisplay.splice(detailsServiceIndex, 1);
                }
            }
        }
        if (!this.displaySearchWithinJournal) {
            servicesToDisplay = servicesToDisplay.filter(
                (value, index, arr) => value.serviceName !== 'searchWithinJournal'
            );
        }
        if(!this.isNgrs()){
            servicesToDisplay = servicesToDisplay.filter(
                (value, index, arr) => value.serviceName !== 'ngrs'
            );
        }
        
        this.servicesArray = servicesToDisplay;
        
        return this.$q.all(promisesArr).then( () => {
            this.isCall =false;
            if (haveNewDelivery) {
                this.servicesArray = servicesToDisplay;
            }
            this.isPromiseResolved = true;
            return this.servicesArray;
        });        
    }

    private setResultFields(data, item, serviceName) {
        if (!data){
            this.nextOffset[serviceName] = undefined;
            this.totalItems[serviceName] = undefined;
            this.moreLikeThisItems[serviceName] = undefined;
            this.moreLikeThisUnfilteredItems[serviceName] = undefined;
        } else {
            this.nextOffset[serviceName] = _get(data, 'data.docs').length;
            let items = this.moreLikeThisService.parseResponse(data, item);
            this.totalItems[serviceName] = _get(data, 'data.info.total');
            this.moreLikeThisItems[serviceName] = items;
            this.moreLikeThisUnfilteredItems[serviceName] = get(data, 'data.docs') || get(data, 'docs');
        }
    }

    private isLocalRecord(item) {
        let srcId = _get(item, 'pnx.control.sourceid');
        if (angular.isArray(srcId)) {
            srcId = srcId[0];
        }
        if (srcId === 'alma') {
            return true;
        }
        return false;
    }

    public setSearchWithinJournalService(item) {
        this.displaySearchWithinJournal = false;
        if (this.configurationUtil.getBackendSystem() !== 'suprima') {
            return;
        }
        let issn = _get(item, 'pnx.addata.issn[0]', undefined);
        let eissn = _get(item, 'pnx.addata.eissn[0]', undefined);
        if (!(issn || eissn)) {
            return;
        }
        let rtype = _get(item, 'pnx.display.type[0]', undefined);
        if (!rtype || (rtype.toLowerCase() !== 'journal' && rtype.toLowerCase() !== 'journals')) {
            return;
        }
        let config = this.configurationUtil.getSearchWithinJournalConfig();
        if (this.configurationUtil.getSummonOverAlma()) {
            if (!config.summonUrl) {
                return;
            }
        } else if (!(config.tab && config.scope)) {
            return;
        }
        this.displaySearchWithinJournal = true;
    }

    public isCalculatePcDeliveryDone() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            return this.calculatePcDeliveryDone;
        }
        return true;
    }

    public isCalculateSvcIdDone() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            return this.calculateSvcIdDone;
        }
        return true;
    }

    public suprimaEnrichers(item) {
        this.calculatePhysicalServiceId(item);
        this.enrichDeliveryWithERTA(item);
        this.calculatePcDelivery(item);
        this.updateGoogleScholarUrls(item);
    }

    public googleScholarEnrich(pnx) {
    	var fullTitle = [pnx.display.title[0]];
    	if (pnx.display.title.length > 1){ 
    		fullTitle[0] = fullTitle[0] + ": " + pnx.display.title[1];
    	}
        this.googleScholarEnrichHandleField("citation_title", fullTitle, false, true);

        this.googleScholarEnrichHandleField("citation_author", pnx.display.creator, true, false);
        this.googleScholarEnrichHandleField("citation_author", pnx.display.contributor, true, false);

		if(pnx.addata.jtitle == null || pnx.addata.jtitle == "") {
			this.googleScholarEnrichHandleField("citation_journal_title", pnx.display.partoftitle, false, true);
		}else{
	        this.googleScholarEnrichHandleField("citation_journal_title", pnx.addata.jtitle, false, true);
	    }
        this.googleScholarEnrichHandleField("citation_conference_title", pnx.addata.atitle, false, true);
        this.googleScholarEnrichHandleField("citation_doi", pnx.addata.doi, false, true);

        this.googleScholarEnrichHandleField("citation_issn", pnx.addata.issn, false, false);
        this.googleScholarEnrichHandleField("citation_issn", pnx.addata.eissn, false, false);

        this.googleScholarEnrichHandleField("citation_isbn", pnx.addata.isbn, false, false);
        this.googleScholarEnrichHandleField("citation_isbn", pnx.addata.eisbn, false, false);

        this.googleScholarEnrichHandleField("citation_isbn", pnx.addata.isbn, false, false);
        this.googleScholarEnrichHandleField("citation_isbn", pnx.addata.eisbn, false, false);

        this.googleScholarEnrichHandleField("citation_volume", pnx.addata.volume, false, true);
        this.googleScholarEnrichHandleField("citation_issue", pnx.addata.issue, false, true);
        this.googleScholarEnrichHandleField("citation_firstpage", pnx.addata.spage, false, true);
        this.googleScholarEnrichHandleField("citation_lastpage", pnx.addata.epage, false, true);

        // not implemented in PNX
        this.googleScholarEnrichHandleField("citation_dissertation_institution", null, false, true);
        this.googleScholarEnrichHandleField("citation_technical_report_institution", pnx.addata.aucorp, false, true);

        // online publication date - no way to distinguish, take same as publication date
        this.googleScholarEnrichHandleField("citation_online_date", pnx.addata.date, false, true);

        this.googleScholarEnrichHandleField("citation_language", pnx.display.language, false, true);
        this.googleScholarEnrichHandleField("citation_publisher", pnx.display.publisher, false, true);
        this.googleScholarEnrichHandleField("citation_publication_date", pnx.addata.date, false, true);
        this.googleScholarEnrichHandleField("robots", ["nofollow"], false, true);
    }

    private googleScholarEnrichHandleField(tagName: String, location: any, subSplit: boolean, onlyFirst: boolean): Array<String> {
        let allElements = new Array<String>();
        if (location != null) {
            if (onlyFirst) {
                if (location[0] != null && location[0] != "") {
                    let element = this.googleScholarEnrichAddElement(tagName, location[0]);
                    if (element) {
                        allElements.push(element);
                    }
                }
            } else {
                for (let element of location) {
                    if (subSplit) {
                        for (let subElement of element.split(GS_STRING_DELIMITER)) {
                            if (subElement) {
                                let newSubElement: String = this.googleScholarEnrichAddElement(tagName, subElement);
                                if (newSubElement) {
                                    allElements.push(newSubElement);
                                }
                            }
                        }
                    } else {
                        let newElement: String = this.googleScholarEnrichAddElement(tagName, element);
                        if (newElement) {
                            allElements.push(newElement);
                        }
                    }
                }
            }
        }
        return allElements;
    }

    private googleScholarEnrichAddElement(tagName: String, element: String): String {
        let elementTrimmed: String = element.trimStart().trimEnd();
        this.addMeta(tagName, elementTrimmed);
        return elementTrimmed;
    }

    private calculatePhysicalServiceId(item) {
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || item.adaptor !== 'Local Search Engine') {
            this.calculateSvcIdDone = true;
            return;
        }
        let delivery = item.delivery;
        if (delivery) {
            if (delivery.physicalServiceId
                || !this.hasHolding(delivery)) {
                this.calculateSvcIdDone = true;
                return;
            }

        this.calculateSvcIdDone = false;
        let recordId = this.getIlsRecordId(item);
        let httpConfig = {
            method: 'GET',
            url: this.restBaseURLs.calculatePhysicalServiceId + '/' + recordId + '?vid=' + this.vid + '&lang=' + this.$translate.use() + '&recordOwner=' + delivery.recordOwner,
            params: null,
            data: null
        };
        let _this = this;
        this.$http(httpConfig)
            .then((response) => {
                _this.updatePhysicalServiceIdAndLinks(item, response.data);
                _this.updateServices(item);
                _this.calculateSvcIdDone = true;
            })
            .finally(() => {
                _this.calculateSvcIdDone = true;
            });
        }

    }

    private getIlsRecordId(item) {
        let delivery = item.delivery;
        if (get(delivery, 'holding[0].ilsApiId')) {
            return delivery.holding[0].ilsApiId;
        } else {
            return item.pnx.control.sourcerecordid[0];
        }
    }


    private hasHolding(delivery) {
        if (delivery && delivery.holding && delivery.holding.length >= 1) {
            return true;
        } else if (delivery && this.hasPCategory(delivery.deliveryCategory)) {
            return true;
        }
        return false;
    }

    private calculatePcDelivery(item) {
        this.calculatePcDeliveryDone = false;
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || (item.adaptor !== 'Primo Central' && item.adaptor !== 'Primo VE Deep Search' && item.adaptor !== 'EbscoLocal' && item.adaptor !== 'WorldCatLocal' && item.adaptor !== 'SummonLocal')) {
            this.calculatePcDeliveryDone = true;
            return;
        }
        let delivery = item.delivery;
        if (delivery) {
        let payload = {
            'doc': item
        };
        let recordId = item.pnx.control.recordid[0];
        let httpConfig = {
            method: 'POST',
            url: this.restBaseURLs.calculatePcDelivery+'/'+encodeURI(recordId)+'?vid='+this.vid + '&lang=' + this.$translate.use(),
            params: null,
            data: payload
        };
        let _this = this;
        this.$http(httpConfig)
            .then((response) => {
                if (item.adaptor === 'WorldCatLocal') {
                    let availability = _get(response, 'data.delivery.availability[0]');
                    if (availability === 'no_inventory') {
                        response.data.delivery.availability = item.delivery.availability;
                    }
                }
                item.delivery = response.data.delivery;
                _this.updateServices(item);
                _this.calculatePcDeliveryDone = true;
            })
            .finally(() => {
                _this.calculatePcDeliveryDone = true;
            });
    }
    }

    private enrichDeliveryWithERTA(item) {
        this.calculatePrimaViewItDeliveryDone = false;
        let delivery = item.delivery;
        if (delivery) {

        // exit this method - dont do enrich, in the following cases::
        // (1) backend system is SUPRIMA
        // (2) there is no electronic category
        // (3) the electronicServices was already populated
        if (this.skipElectronicEnrich(item)) {
            this.calculatePrimaViewItDeliveryDone = true;
            return;
        }
        let url = this.$location.url();
        let recordId = item.pnx.control.recordid[0];
        let institutionCode = _get(item, 'delivery.recordInstitutionCode');
        let vid = this.vid;
        if (institutionCode && !this.hasECategory(delivery.deliveryCategory)) {
            vid = institutionCode + ":SD";
        }
        let httpConfig = {
            method: 'GET',
            url: this.restBaseURLs.prepareElectorincRTA + '/' + recordId + '?vid=' + vid + '&lang=' + this.$translate.use(),
            params: {'googleScholar': true},
            data: null
        };

        this.$http(httpConfig)
            .then(
                (response) => {
                    this.mergeDeliveryWithEDelivery(item, response.data, delivery.electronicServices !== null);
                    this.calculatePrimaViewItDeliveryDone = true;
                    this.updateServices(item);
                    this.updateGoogleScholarUrls(item);
                }
            ).finally(() => {
            this.calculatePrimaViewItDeliveryDone = true;
        });
    }

    }

    public updateAvailability(doc: PrimoResponse.IDoc) {
        if ((this.configurationUtil.getLocationsConfiguration() &&
            this.configurationUtil.getLocationsConfiguration().rta !== 'none')
            || (doc.delivery && doc.delivery.almaInstitutionsList)
        ) {
            this.rtaService.updateAvailability([doc], {rtaOnAllInstitutions: 'true'});
        }
    }

    private skipElectronicEnrich(item) {
        let delivery = item.delivery;
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || item.context === 'SP' || item.adaptor === 'Primo Central' || item.adaptor === 'Primo VE Deep Search' || item.adaptor === 'EbscoLocal' || item.adaptor === 'WorldCatLocal'
            || !this.hasEOrDOrRCategory(delivery.deliveryCategory)) {
            return true;
        }
        return false;
    }

    private buildGetitServicesArray(item: PrimoResponse.IDoc, type: string): nui.IGetit1Service[] {
        if (!item) {
            return null;
        }
        let getItArray = this.getLinkByAction(item, type);

        let array = [];
        if (this.configurationUtil.isSuprima()) {
            //in case the e-delivery is not calculated yet but we know it exists so we need to have the viewIt tab at the time the page is loaded
            //this link will get overrided after the e-delivery is calculated
            let delCategories = item.delivery ? item.delivery.deliveryCategory : [];
            if (delCategories.indexOf('Alma-E') != -1 || delCategories.indexOf('Alma-D') != -1 || delCategories.indexOf('Remote Search Resource') != -1) {
                if (getItArray.filter(value => value.category === 'Alma-E' || value.category === 'Alma-D' ||  value.category === 'Remote Search Resource').length == 0) {
                    array.push(
                        {
                            scrollId: 'getit_link1_' + 0,
                            serviceName: 'Viewit',
                            title: 'nui.getit.service_viewit'
                        }
                    );
                }
            }
        }

        getItArray.forEach((value, index, arr) => {
            let delCategory = value.category;
            let delCategories = item.delivery ? item.delivery.deliveryCategory : [];
            let delIndex = indexOf(delCategories, delCategory);
            if (this.configurationUtil.isSuprima() && delIndex === -1 && (delCategory === 'Alma-D' || delCategory === 'Alma-E')) {
                delCategory = delCategory === 'Alma-E' ? 'Alma-D' : 'Alma-E';
                delIndex = indexOf(delCategories, delCategory);
            }
            let serviceName = '';
            if (delIndex !== -1 && item.delivery.serviceMode) {
                serviceName = item.delivery.serviceMode[delIndex];
            }
            if (value.links && value.links[0]) {
                let scrollIdIndex = array.length;
                if (serviceName === 'display') {
                    this.viewOnlineScrollId = 'getit_link1_' + scrollIdIndex;
                }
                array.push(
                    {
                        scrollId: 'getit_link1_' + scrollIdIndex,
                        serviceName: serviceName,
                        title: 'nui.getit.' + value.links[0].getItTabText,
                        linkElement: value
                    }
                );
            }
        });

        //Display locations even if there is no Getit1
        if (!this.configurationUtil.isSuprima()) {
            let getit1services = array.map(s => s.serviceName);
            if (indexOf(getit1services, 'ovp') === -1 &&
                indexOf(getit1services, 'ovl') === -1 &&
                indexOf(getit1services, 'activate') === -1) {
                let holdingArray = _get(item, 'delivery.holding', []);
                if (holdingArray && holdingArray.length > 0) {
                    array.push(
                        {
                            scrollId: 'getit_link1_' + 0,
                            serviceName: this.locationService.isOvpLocation(holdingArray[0]) ? 'ovp' : 'ovl',
                            title: 'nui.getit.tab1_check',
                            linkElement: null
                        }
                    );
                }
            }
        }


        return array;
    }


    private buildGetit2ServicesArray(item: PrimoResponse.IDoc, type: string): nui.IGetit1Service[] {
        if (!item) {
            return null;
        }
        if (item.delivery && item.delivery.GetIt2) {
            let array: nui.IGetit2Service[] = [];
            let getit2 = item.delivery.GetIt2;
            getit2.hyperlinkText = getit2.getItTabText ? getit2.getItTabText : '';
            array.push(
                {
                    scrollId: 'getit_link2',
                    serviceName: getit2.serviceModeGetit2,
                    title: 'getit.' + getit2.getItTabText,
                    linkElement: {links: [getit2]}
                });

            return array;
        }
    }


    private hasEOrDOrRCategory(deliveryCategoryArray) {
        if (deliveryCategoryArray === null) {
            return false;
        }
        for (let i = 0; i < deliveryCategoryArray.length; i++) {
            if (deliveryCategoryArray[i] === 'Alma-E' || deliveryCategoryArray[i] === 'Alma-D' || deliveryCategoryArray[i] === 'Remote Search Resource') {
                return true;
            }
        }
        return false;
    }

    private hasECategory(deliveryCategoryArray) {
        if (deliveryCategoryArray === null) {
            return false;
        }
        for (let i = 0; i < deliveryCategoryArray.length; i++) {
            if (deliveryCategoryArray[i] === 'Alma-E') {
                return true;
            }
        }
        return false;
    }

    private hasPCategory(deliveryCategoryArray) {
        if (deliveryCategoryArray === null) {
            return false;
        }
        for (let i = 0; i < deliveryCategoryArray.length; i++) {
            if (deliveryCategoryArray[i] === 'Alma-P') {
                return true;
            }
        }
        return false;
    }

    private mergeDeliveryWithEDelivery(item, eDelivery, isAlreadyCalculated) {
        let delivery = item.delivery;
        if (eDelivery === null || !eDelivery.electronicServices) {
            //we initialy got alma-E, but it was removed with DisplayLogic, need to align the delivery
            let eDelCategory = findIndex(delivery.deliveryCategory, (dc) => dc === 'Alma-E');
            if (eDelCategory !== -1) {
                delivery.deliveryCategory.splice(eDelCategory, 1);
            }
            let availability = findIndex(delivery.availability, (av) => av === 'not_restricted');
            if (availability !== -1) {
                delivery.availability.splice(availability, 1);
            }
            return;
        }
        for (let service of eDelivery.electronicServices){
            service['isFromEDelivery'] = true;
        }
        if (isAlreadyCalculated) {
            let currentServices = get(item,'delivery.electronicServices', []);
            let nonEDeliveryServices = currentServices.filter((service)=>!service['isFromEDelivery']);
            item.delivery.electronicServices = nonEDeliveryServices.concat(eDelivery.electronicServices);
            return;
        }
        this.updateLinks(item, eDelivery);
        if (delivery.GetIt1 === null) {
            item.delivery.electronicServices = eDelivery.electronicServices;
            item.delivery.GetIt1 = eDelivery.GetIt1;
            item.delivery.serviceMode = eDelivery.serviceMode;
            item.delivery.availabilityLinks = eDelivery.availabilityLinks;
            return;
        }
        delivery.electronicServices = eDelivery.electronicServices;
        delivery.availabilityLinks.unshift(eDelivery.availabilityLinks[0]);
        delivery.displayedAvailability = eDelivery.displayedAvailability;
        delivery.GetIt1.unshift(eDelivery.GetIt1[0]);
    }

    private updateGoogleScholarUrls(item) {
        if (item.delivery) {
            for (let i in item.delivery.electronicServices) {
                if (item.delivery.electronicServices[i].pdfFilesUrl) {
                    for (let pdfFileUrl of item.delivery.electronicServices[i].pdfFilesUrl) {
                        this.addMeta("citation_pdf_url", pdfFileUrl);
                    }
                }
            }
        }
    }

    private addMeta(name, content) {
        if (content === undefined) {
            return;
        }
        let meta = document.createElement("META");
        meta.setAttribute("name", name);
        meta.setAttribute("content", content);
        document.head.appendChild(meta);
    }

    private updatePhysicalServiceIdAndLinks(item, resp) {
        let delivery = item.delivery;
        if (!delivery || resp == null) {
            return;
        }
        delivery.physicalServiceId = resp.physicalServiceId;
        this.updateLinks(item, resp);
    }

    private updateLinks(item, resp) {
        let delivery = item.delivery;
        if ((delivery.link === undefined || delivery.link === null) && resp.link) {
            item.delivery = resp.link;
            return;
        }
        if (resp.link) {
            let idx = delivery.link.length;
            resp.link = resp.link.map((item, index, array) => this.updateIndex(item, index, idx));
            item.delivery.link = union(delivery.link, resp.link);
        }
    }

    private updateIndex(item, index, idx) {
        item['@id'] = '_:' + (index + idx);
        return item;
    }

    private getLinkByAction(item, action) {
        let getItArray = this.getGetItObject(item, action);
        return getItArray && (getItArray.length > 0) ? getItArray : [];
    }

    private getGetItObject(item, action) {
        let getItArray = [];
        let filterFunction = null;
        switch (action) {
            case 'getit_link1':
                if (!item.delivery || !item.delivery.GetIt1) {
                    return null;
                }
                getItArray = item.delivery.GetIt1.links || item.delivery.GetIt1;
                break;
            case 'getit_link2':
                getItArray = item.delivery.GetIt2;
                break;

            default:
                return null;
        }

        return getItArray;
    }

    private parseServicesWithConfiguration(item, type) {
        if (type === 'getit_link1') {
            return this.buildGetitServicesArray(item, type);
        }
        if (type === 'getit_link2') {
            return this.buildGetit2ServicesArray(item, type);
        }

        return this.servicesDirectives[type];
    }

    private handleCitationTrialsAndTimesCitedVisibilityForSuprima(services, citationTrailsFullviewLinkService, timesCitedService) {
        let citationTrialAndTimesCitedConfigured = true;
        if (services.filter(function (e) {
            return e.serviceName == 'citationTrails';
        }).length > 0) {
            citationTrailsFullviewLinkService.setShowCitationTrialForSuprima(true);
        } else {
            citationTrailsFullviewLinkService.setShowCitationTrialForSuprima(false);
            citationTrialAndTimesCitedConfigured = false;
        }

        if (services.filter(function (e) {
            return e.serviceName == 'timesCited';
        }).length > 0) {
            timesCitedService.setShowTimesCitedForSuprima(true);
        } else {
            timesCitedService.setShowTimesCitedForSuprima(false);
            citationTrialAndTimesCitedConfigured = false;
        }

        //To prevent from the citations to appear twice
        if (citationTrialAndTimesCitedConfigured) {
            services = services.filter(function (e) {
                return e.serviceName != 'timesCited';
            });
        }

        return services;
    }

    public getServicesDirectives() {
        return this.servicesDirectives;
    }

    public setServiceTitle(serviceName, label) {
        this.servicesDirectives[serviceName].title = label;
    }

    public addServiceDirective(serviceName, serviceDirective) {
        this.servicesDirectives[serviceName] = serviceDirective;
    }

    public disableService(serviceName) {
        this.servicesDirectives[serviceName].isDisabled = true;
    }

    public calculatePrimaViewItDone() {
        return this._calculatePrimaViewItDeliveryDone && this.isCalculatePcDeliveryDone();
    }

    set calculatePrimaViewItDeliveryDone(isDone) {
        this._calculatePrimaViewItDeliveryDone = isDone;
    }

    private isNgrs(){
        return window.appConfig['system-configuration'].ngrs_enabled;
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/fullView.service.ts